/* eslint-disable no-unused-vars */
import axios from 'axios';

/**
 *
 * Create a new instance of axios with a custom config.
 *
 */

const http = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {},
    auth: {
        username: process.env.REACT_APP_AUTH_USERNAME,
        password: process.env.REACT_APP_AUTH_PASSWORD,
    },
});

// Add a response interceptor
http.interceptors.response.use(
    (response) =>
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        response,
    (error) =>
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        Promise.reject(error)
);
export default http;
